<div class="financial-report bg-white">
  <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-6 md:mb-8">
    <div>
      <h3 class="text-xl md:text-2xl font-extrabold text-gray-900 font-['Inter'] uppercase">Simulação de custos</h3>
      <p class="text-sm md:text-base text-gray-500 mt-2 leading-relaxed">
        Esta simulação tem caráter informativo e ilustrativo, baseada nos dados informados. Os valores apresentados são estimativas e não substituem análises financeiras, jurídicas ou tributárias individualizadas. Além dos custos de aquisição e impostos, a análise completa de um imóvel em leilão pode envolver outros fatores que variam conforme o caso, como eventuais dívidas, situação de posse, custos jurídicos, despesas de reforma e custos de manutenção, que não estão contemplados nesta simulação.
      </p>
    </div>
  </div>

  <!-- KPI cards -->
  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 mb-5">
    <div class="p-4 bg-gray-50 border border-gray-100 rounded-md">
      <div class="text-xs text-gray-500 ">Custo total estimado</div>
      <div class="text-lg font-semibold text-gray-900">
        {{ display('computed.total_cost_brl_cents', 'money') }}
      </div>
    </div>

    <div class="p-4 bg-gray-50 border border-gray-100 rounded-md">
      <div class="text-xs text-gray-500 ">Venda líquida</div>
      <div class="text-lg font-semibold text-gray-900 ">
        {{ display('sale_projection.sale_price_net_brl_cents', 'money') }}
      </div>
    </div>

    <div class="p-4 bg-gray-50 border border-gray-100 rounded-md">
      <div class="text-xs text-gray-500 ">Resultado estimado</div>
      <div class="text-lg font-semibold text-gray-900 ">
        {{ display('computed.profit_brl_cents', 'money') }}
      </div>
    </div>

    <div class="p-4 bg-gray-50 border border-gray-100 rounded-md">
      <div class="text-xs text-gray-500 ">Retorno estimado</div>
      <div class="text-lg font-semibold text-gray-900 ">
        {{ display('computed.roi', 'percent') }}
      </div>
    </div>
  </div>

  <!-- Tables -->
  <div class="space-y-4">
    <div *ngFor="let t of costReport.tables" class="financial-report-section">
      <div class="px-4 py-3 bg-gray-50 border border-gray-100 rounded-t-md">
        <h3 class="font-semibold text-gray-900 ">{{ t.title }}</h3>
        <p class="text-sm text-gray-500 mt-1">{{ t.description }}</p>
      </div>

      <div class="relative overflow-x-auto financial-report-table-wrap">
        <table class="financial-report-table w-full text-sm text-left text-gray-500 table-fixed">

          <thead class="text-xs text-gray-700 uppercase bg-gray-50  ">
            <tr>
              <th class="px-6 py-3 w-2/5" scope="col">Item</th>
              <th class="px-6 py-3 w-1/5" scope="col">Valor</th>
              <th class="px-6 py-3 w-1/5 text-right" scope="col">Valor R$</th>
              <th class="px-6 py-3 w-1/5 text-right" scope="col">Valor estimado</th>
            </tr>
          </thead>

          <tbody>
          <tr *ngFor="let r of t.rows" class="bg-white ">
            <td class="px-6 py-4 font-medium text-gray-900" data-label="Item">
              {{ r.label }}
            </td>

            <td class="px-6 py-4" data-label="Valor">
              {{ display(r.path, r.format) }}
            </td>

            <td class="px-6 py-4 text-right" data-label="Valor R$">
              {{ display(r.path, r.format === 'percent' ? 'real' : r.format) }}
            </td>

            <td class="px-6 py-4" data-label="Valor estimado">
              <ng-container *ngIf="isEditable(r.path); else na">
                <input
                  (ngModelChange)="onCostFieldChange(r.path, $event)"
                  [attr.placeholder]="r.format === 'money' ? 'R$ 0,00' : (r.format === 'percent' ? '0,05 ou 5%' : '')"
                  [ngModel]="getValue(r.path)"
                  class="w-full text-right bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:lue-500 p-2.5"
                />
              </ng-container>
              <ng-template #na>
                <div class="w-full text-right">
                  <span class="text-gray-400">—</span>
                </div>
              </ng-template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- Optional hint row -->
      <div class="px-4 py-3 text-xs text-gray-500 ">
        Dica: em campos monetários você pode digitar <span class="font-medium">R$ 1.234,56</span>.
      </div>
    </div>
  </div>
</div>
<div class="financial-report-summary grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 mt-5">
  <div class="p-4 border rounded-md bg-gray-50 border-gray-300 ">
    <div class="text-xs text-gray-500 ">Venda bruta estimada</div>
    <div class="text-lg font-semibold text-gray-700 ">
      {{ display('sale_projection.sale_price_gross_brl_cents', 'money') }}
    </div>
  </div>

  <div class="p-4 border rounded-md bg-gray-50 border-gray-300">
    <div class="text-xs text-gray-500 ">Venda líquida estimada</div>
    <div class="text-lg font-semibold text-gray-700 ">
      {{ display('sale_projection.sale_price_net_brl_cents', 'money') }}
    </div>
  </div>

  <div class="p-4 border rounded-md bg-gray-50 border-gray-300">
    <div class="text-xs text-gray-500 ">Lucro estimado</div>
    <div class="text-lg font-semibold text-gray-700 ">
      {{ display('computed.profit_brl_cents', 'money') }}
    </div>
  </div>

  <div class="p-4 border rounded-md bg-gray-50 border-gray-300">
    <div class="text-xs text-gray-500 ">Retorno estimado sobre o investimento (indicador ilustrativo)</div>
    <div class="text-lg font-semibold text-gray-700 ">
      {{ display('computed.roi', 'percent') }}
    </div>
  </div>
</div>
<div class="grid grid-cols-1">
  <div class="mt-3">
    <p class="text-sm text-gray-500 leading-normal">As projeções dependem diretamente dos dados informados pelo usuário e de premissas automatizadas, podendo variar significativamente.</p>
    <p class="text-sm text-gray-500 leading-normal">As informações apresentadas não substituem análises profissionais individualizadas</p>
  </div>
</div>
